<template>
    <div class="outer">
        <!-- 选择货物弹窗 -->
        <el-dialog width="65%" title="选择货物" :close-on-click-modal="false" v-if="selectVisible"
            :visible="selectVisible" @close="selectVisible = false">
            <div class="topSearch">
                <el-form class="queryRow" inline>
                    <el-form-item label="货物分类" class="queryCol">
                        <el-cascader style="width: 100%" v-model="goodsQueryForm.goodsClassCode"
                            :props="{ label: 'goodsClassName', value: 'goodsClassCode', emitPath: false, checkStrictly: true }"
                            :options="classOptions" @change="onGoodsSearch" clearable @clear="onGoodsSearch">
                        </el-cascader>
                    </el-form-item>
                    <el-form-item label="货物名称" class="queryCol">
                        <el-input placeholder="请输入" clearable @clear="onGoodsSearch" v-model="goodsQueryForm.goodsName"></el-input>
                    </el-form-item>
                    <el-form-item class="queryCol">
                        <el-button type="primary" icon="el-icon-search" @click="onGoodsSearch">搜索</el-button>
                    </el-form-item>
                </el-form>
            </div>
            <el-table v-loading="goodsLoading" border :row-style="{ height: '50px' }"
                style="width: 100%;height: 55vh;overflow: auto;" :data="goodsList">
                <el-table-column label="选择" width="55">
                    <template slot-scope="scope">
                        <el-checkbox v-model="scope.row.checked"></el-checkbox>
                    </template>
                </el-table-column>
                <el-table-column align="center" label="货物名称" prop="goodsName"></el-table-column>
                <el-table-column align="center" label="货物类别" prop="goodsClassName"></el-table-column>
                <el-table-column align="center" label="品牌" prop="goodsBrand"></el-table-column>
                <el-table-column align="center" label="货物型号" prop="goodsType"></el-table-column>
                <el-table-column align="center" label="货物配置" prop="goodsConfig">
                    <template slot-scope="scope">
                        <el-popover trigger="hover" placement="top" width="300">
                            <p>{{ scope.row.goodsConfig }}</p>
                            <div slot="reference">
                                <p size="medium" style="white-space: nowrap;overflow: hidden;text-overflow:ellipsis;">{{ scope.row.goodsConfig }}</p>
                            </div>
                        </el-popover>
                    </template>
                </el-table-column>
                <el-table-column align="center" label="库存数量" prop="whGoodsNum" width="100"></el-table-column>
                <el-table-column align="center" label="货物单位" prop="goodsUnit"></el-table-column>
            </el-table>
            <div class="pageination">
                <el-pagination @size-change="onGoodsSizeChange" @current-change="onGoodsCurrentChange" :total="goodsTotal"
                    :page-size="goodsPageSize" :page-sizes="[10, 20, 30, 40, 50, 100]" :current-page="goodsPage"
                    background layout="sizes, prev, pager, next, jumper, ->, total">
                </el-pagination>
            </div>
            <div class="dialog-footer" style="display: flex; justify-content: flex-end; margin-top: 10px;">
                <el-button type="primary" @click="confirmSelectGoods">确 定</el-button>
            </div>
        </el-dialog>

        <!-- 新建自采单弹窗 -->
        <el-dialog width="80%" destroy-on-close :title="purchaseDialogTitle" :close-on-click-modal="false"
            :visible="purchaseVisible" @close="closePurchaseDialog">
            <el-card style="margin-bottom: 20px">
                <div class="flex-space-between listTop" slot="header">
                    <span>基本信息</span>
                </div>
                <el-form ref="purchaseForm" :model="purchaseForm" :rules="purchaseRules" label-width="110px">
                    <el-row :gutter="100">
                        <el-col :span="12">
                            <el-form-item label="固定渠道" prop="channelId" required>
                                <el-select filterable style="width: 100%" v-model="purchaseForm.channelId"
                                    placeholder="仅可选已生效固定渠道">
                                    <el-option v-for="item in channelList" :key="item.id" :value="item.id"
                                        :label="item.supplierName + ' - ' + item.goodsClassName"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="备注" prop="remarks">
                                <el-input style="width: 100%" v-model="purchaseForm.remarks" placeholder="请输入备注"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </el-card>

            <el-card>
                <div class="flex-space-between listTop" slot="header">
                    <span>货物明细（库存量大于自采量时须填写原因）</span>
                    <el-button type="primary" icon="el-icon-plus" @click="selectVisible = true">选择货物</el-button>
                </div>
                <el-table border :row-style="{ height: '50px' }" style="width: 100%" :data="purchaseForm.itemList">
                    <el-table-column align="center" label="货物名称" prop="goodsName"></el-table-column>
                    <el-table-column align="center" label="货物型号" prop="goodsType"></el-table-column>
                    <el-table-column align="center" label="库存数量" prop="whGoodsNum" width="90"></el-table-column>
                    <el-table-column align="center" label="自采数量" prop="goodsNum" width="130">
                        <template slot-scope="scope">
                            <el-input style="width: 110px" type="number" :min="1" v-model="scope.row.goodsNum"
                                @input="onRowChange(scope.row)"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" label="单价(元)" prop="price" width="120">
                        <template slot-scope="scope">
                            <el-input style="width: 100px" type="number" :min="0" v-model="scope.row.price"
                                @input="onRowChange(scope.row)"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" label="金额(元)" prop="amount" width="110">
                        <template slot-scope="scope">
                            {{ ((scope.row.goodsNum || 0) * (scope.row.price || 0)).toFixed(2) }}
                        </template>
                    </el-table-column>
                    <el-table-column align="center" label="商机" prop="chanceId" width="180">
                        <template slot-scope="scope">
                            <el-select style="width: 100%" filterable v-model="scope.row.chanceId" placeholder="选择商机(可选)"
                                clearable>
                                <el-option v-for="(item, i) in projectList" :key="i" :label="item.name"
                                    :value="item.code"></el-option>
                            </el-select>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" label="超量原因" prop="overReason" width="180">
                        <template slot-scope="scope">
                            <el-input style="width: 100%" v-if="scope.row.whGoodsNum > scope.row.goodsNum"
                                v-model="scope.row.overReason" placeholder="库存充足，请填写超量采购原因"></el-input>
                            <span v-else>--</span>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" label="操作" prop="operate" width="80">
                        <template slot-scope="scope">
                            <el-button type="text" style="color: #F56C6C" icon="el-icon-delete"
                                @click="purchaseForm.itemList.splice(scope.$index, 1)">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="totalPrice">
                    <div class="price">合计: {{ totalAmount }}元</div>
                </div>
            </el-card>

            <span slot="footer" class="dialog-footer">
                <el-button @click="closePurchaseDialog">取 消</el-button>
                <el-button type="primary" :loading="btnLoading" @click="submitPurchase">确 定</el-button>
            </span>
        </el-dialog>

        <!-- 详情弹窗 -->
        <el-dialog width="70%" destroy-on-close title="自采单详情" :close-on-click-modal="false"
            :visible="detailVisible" @close="detailVisible = false">
            <el-descriptions :column="2" border style="margin-bottom: 20px;">
                <el-descriptions-item label="自采单号">{{ detailForm.purchaseNo || '--' }}</el-descriptions-item>
                <el-descriptions-item label="固定渠道">{{ detailForm.channelName || '--' }}</el-descriptions-item>
                <el-descriptions-item label="自采单状态">{{ detailForm.purchaseStateName || statusName(detailForm.purchaseState) }}</el-descriptions-item>
                <el-descriptions-item label="总金额">{{ detailForm.totalAmount }}元</el-descriptions-item>
            </el-descriptions>
            <el-table border :row-style="{ height: '50px' }" style="width: 100%" :data="detailForm.itemList || []">
                <el-table-column align="center" label="货物名称" prop="goodsName"></el-table-column>
                <el-table-column align="center" label="货物型号" prop="goodsType"></el-table-column>
                <el-table-column align="center" label="自采数量" prop="goodsNum"></el-table-column>
                <el-table-column align="center" label="单价(元)" prop="price"></el-table-column>
                <el-table-column align="center" label="金额(元)" prop="amount"></el-table-column>
                <el-table-column align="center" label="商机" prop="chanceName"></el-table-column>
                <el-table-column align="center" label="超量原因" prop="overReason"></el-table-column>
            </el-table>
        </el-dialog>

        <!-- 审批记录弹窗 -->
        <el-dialog width="50%" destroy-on-close title="审批记录" :close-on-click-modal="false"
            :visible="approvalRecordVisible" @close="approvalRecordVisible = false">
            <template v-if="stageList.length > 0">
                <el-timeline style="margin-top: 30px">
                    <el-timeline-item :timestamp="item.endTime" v-for="(item, i) in stageList"
                        :type="item.approvalResult === '1' ? 'success' : item.approvalResult === '2' ? 'danger' : ''"
                        :key="i">
                        {{ i + 1 }}.<template v-if="item.approvalResult">
                            【已审批-{{ item.approvalResultName }}】, 【操作人：{{ item.dealUserName }}】, 【意见/建议：{{ item.opinion }}】
                        </template>
                        <template v-else>
                            【待审批】 【操作人：{{ item.dealUserName }}】
                        </template>
                    </el-timeline-item>
                </el-timeline>
                <div style="position: absolute;bottom: 20px;right: 20px;">
                    当前审批人: {{ currentApprovalUser }}
                </div>
            </template>
            <el-empty v-else description="无需审批"></el-empty>
        </el-dialog>

        <!-- 自采审批弹窗 -->
        <el-dialog width="45%" destroy-on-close title="审批自采单" :close-on-click-modal="false"
            :visible="approveVisible" @close="approveVisible = false">
            <el-descriptions :column="2" border>
                <el-descriptions-item label="自采单号">{{ approveForm.purchaseNo || '--' }}</el-descriptions-item>
                <el-descriptions-item label="固定渠道">{{ approveForm.channelName || '--' }}</el-descriptions-item>
                <el-descriptions-item label="自采人">{{ approveForm.createUserName || '--' }}</el-descriptions-item>
                <el-descriptions-item label="总金额">{{ approveForm.totalAmount }}元</el-descriptions-item>
            </el-descriptions>
            <span slot="footer" class="dialog-footer">
                <el-button type="danger" @click="approvalPurchase(2)">驳 回</el-button>
                <el-button type="primary" @click="approvalPurchase(1)">通 过</el-button>
            </span>
        </el-dialog>

        <el-tabs v-model="activeName" type="card">
            <!-- 我的自采单（销售 2/3） -->
            <el-tab-pane label="我的自采单" name="1">
                <div class="topSearch">
                    <el-form class="queryRow" inline :model="queryForm">
                        <el-form-item label="自采单状态" class="queryCol">
                            <el-select v-model="queryForm.purchaseState" clearable placeholder="请选择" @change="onSearch" @clear="onSearch">
                                <el-option value="1" label="草稿"></el-option>
                                <el-option value="2" label="审批中"></el-option>
                                <el-option value="3" label="审批通过"></el-option>
                                <el-option value="4" label="已驳回"></el-option>
                                <el-option value="5" label="已完成"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item class="queryCol">
                            <el-button type="primary" icon="el-icon-search" @click="onSearch">搜索</el-button>
                        </el-form-item>
                    </el-form>
                    <el-button type="primary" icon="el-icon-plus" @click="openPurchaseDialog('add')">新建自采单</el-button>
                </div>

                <el-table v-loading="loading" border class="table" :row-style="{ height: '50px' }"
                    style="width: 100%;height: 68vh;overflow: auto;" :data="purchaseList">
                    <template slot="empty">
                        <el-empty :image-size="150"></el-empty>
                    </template>
                    <el-table-column align="center" label="自采单号" prop="purchaseNo" width="180"></el-table-column>
                    <el-table-column align="center" label="固定渠道" prop="channelName"></el-table-column>
                    <el-table-column align="center" label="自采单状态" prop="purchaseState">
                        <template slot-scope="scope">
                            <el-tag :type="statusTagType(scope.row.purchaseState)">{{ statusName(scope.row.purchaseState) }}</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" label="总金额(元)" prop="totalAmount"></el-table-column>
                    <el-table-column align="center" label="备注" prop="remarks"></el-table-column>
                    <el-table-column align="center" label="创建时间" prop="createTime" min-width="130" :formatter="dateTimeTwoLine" class-name="cell-two-line"></el-table-column>
                    <el-table-column align="center" label="操作" prop="operate" width="280">
                        <template slot-scope="scope">
                            <el-button type="text" icon="el-icon-document"
                                @click="openDetail(scope.row)">详情</el-button>
                            <el-button type="text" icon="el-icon-s-claim"
                                @click="openApprovalRecord(scope.row)">审批记录</el-button>
                            <el-button type="text" icon="el-icon-edit" v-if="scope.row.purchaseState == 1 || scope.row.purchaseState == 4"
                                @click="openPurchaseDialog('edit', scope.row)">修改</el-button>
                            <el-button type="text" style="color: #F56C6C" icon="el-icon-delete"
                                v-if="scope.row.purchaseState == 1 || scope.row.purchaseState == 4"
                                @click="deletePurchase(scope.row)">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>

                <div class="pageination">
                    <el-pagination @size-change="onSizeChange" @current-change="onCurrentChange" :total="total"
                        :page-size="queryForm.limit" :page-sizes="[10, 20, 30, 40, 50, 100]"
                        :current-page="queryForm.page" background layout="sizes, prev, pager, next, jumper, ->, total">
                    </el-pagination>
                </div>
            </el-tab-pane>

            <!-- 自采审批（事业部总监 92/99/141 / 总经理 8） -->
            <el-tab-pane label="自采审批" name="2" v-if="canApprove">
                <div class="topSearch">
                    <el-form class="queryRow" inline :model="apprQueryForm">
                        <el-form-item label="本人是否审批" class="queryCol">
                            <el-select v-model="apprQueryForm.func" @change="onApprSearch">
                                <el-option :value="2" label="未审批"></el-option>
                                <el-option :value="1" label="已审批"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-form>
                </div>

                <el-table v-loading="apprLoading" border class="table" :row-style="{ height: '50px' }"
                    style="width: 100%;height: 68vh;overflow: auto;" :data="apprList">
                    <template slot="empty">
                        <el-empty :image-size="150"></el-empty>
                    </template>
                    <el-table-column align="center" label="自采单号" prop="purchaseNo" width="180"></el-table-column>
                    <el-table-column align="center" label="固定渠道" prop="channelName"></el-table-column>
                    <el-table-column align="center" label="自采人" prop="createUserName"></el-table-column>
                    <el-table-column align="center" label="总金额(元)" prop="totalAmount"></el-table-column>
                    <el-table-column align="center" label="自采单状态" prop="purchaseState">
                        <template slot-scope="scope">
                            <el-tag :type="statusTagType(scope.row.purchaseState)">{{ statusName(scope.row.purchaseState) }}</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" v-if="apprQueryForm.func === 1" label="审批意见" prop="opinion"></el-table-column>
                    <el-table-column align="center" label="操作" prop="operate" width="200">
                        <template slot-scope="scope">
                            <el-button type="text" icon="el-icon-document"
                                @click="openApproveDialog(scope.row)">审批</el-button>
                        </template>
                    </el-table-column>
                </el-table>

                <div class="pageination">
                    <el-pagination @size-change="onApprSizeChange" @current-change="onApprCurrentChange"
                        :total="apprTotal" :page-size="apprQueryForm.limit" :page-sizes="[10, 20, 30, 40, 50, 100]"
                        :current-page="apprQueryForm.page" background
                        layout="sizes, prev, pager, next, jumper, ->, total">
                    </el-pagination>
                </div>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>
<script>
import { getGoodsClassList, getGoodsByPage } from '@/api/goods/goodsBusiness.js';
import { getProjects } from '@/api/work/WorkOrderList.js';
import { approvalStageList, applyApprovalReject } from '@/api/goods/buyForm.js';
import { getPersonalPurchaseList, addPersonalPurchase, queryPersonalPurchase, deletePersonalPurchase, personalPurchaseApprovedList, getActiveFixedChannelList } from '@/api/goods/personalPurchase.js';
import { isSales, canApprovePersonalPurchase } from "@/views/goods/permission.js";
export default {
    data() {
        return {
            activeName: '1',
            canApprove: canApprovePersonalPurchase(), // 自采审批（事业部总监 92/99/141 / 总经理 8）
            loading: false,
            total: 0,
            purchaseList: [],
            queryForm: {
                purchaseState: null,
                page: 1,
                limit: 10,
            },
            // 新建/编辑
            purchaseVisible: false,
            purchaseDialogType: '',
            purchaseDialogTitle: '',
            purchaseForm: {
                channelId: '',
                remarks: '',
                itemList: [],
            },
            purchaseRules: {
                channelId: [
                    { required: true, message: '请选择固定渠道' },
                ],
            },
            channelList: [], // 已生效固定渠道
            projectList: [], // 自己名下商机
            // 选择货物
            selectVisible: false,
            goodsLoading: false,
            goodsList: [],
            goodsTotal: 0,
            goodsPage: 1,
            goodsPageSize: 10,
            goodsQueryForm: {
                goodsClassCode: '',
                goodsName: '',
                category: '行政',
            },
            classOptions: [],
            btnLoading: false,
            // 详情
            detailVisible: false,
            detailForm: {},
            // 审批记录
            stageList: [],
            approvalRecordVisible: false,
            // 审批
            approveVisible: false,
            approveForm: {},
            apprLoading: false,
            apprTotal: 0,
            apprList: [],
            apprQueryForm: {
                func: 2,
                page: 1,
                limit: 10,
            },
        }
    },
    computed: {
        totalAmount() {
            return (this.purchaseForm.itemList || []).reduce((sum, item) => {
                return sum + ((item.goodsNum || 0) * (item.price || 0));
            }, 0).toFixed(2);
        },
        currentApprovalUser() {
            return this.stageList.find(item => !item.approvalResult)?.dealUserName || '无';
        }
    },
    created() {
        this.activeName = '1';
        this.getPurchaseList();
        this.getChannelList();
        this.loadProjectList();
        this.getGoodsClassList();
        if (this.canApprove) this.getApprList();
    },
    methods: {
        statusName(status) {
            switch (String(status)) {
                case '1': return '草稿';
                case '2': return '审批中';
                case '3': return '审批通过';
                case '4': return '已驳回';
                case '5': return '已完成';
                default: return '--';
            }
        },
        statusTagType(status) {
            switch (String(status)) {
                case '1': return 'info';
                case '2': return 'warning';
                case '3': return 'success';
                case '4': return 'danger';
                case '5': return 'primary';
                default: return '';
            }
        },
        // 我的自采单列表
        getPurchaseList() {
            this.loading = true;
            getPersonalPurchaseList(this.queryForm).then(res => {
                this.loading = false;
                if (res && res.code === 200) {
                    this.total = res.count;
                    this.purchaseList = res.data;
                } else {
                    this.purchaseList = [];
                    this.total = 0;
                }
            }).catch(() => {
                this.loading = false;
                this.purchaseList = [];
                this.total = 0;
            });
        },
        onSearch() {
            this.queryForm.page = 1;
            this.getPurchaseList();
        },
        onSizeChange(e) {
            this.queryForm.page = 1;
            this.queryForm.limit = e;
            this.getPurchaseList();
        },
        onCurrentChange(e) {
            this.queryForm.page = e;
            this.getPurchaseList();
        },
        // 新建/编辑
        openPurchaseDialog(type, row) {
            this.purchaseDialogType = type;
            if (type === 'add') {
                this.purchaseDialogTitle = '新建自采单';
                this.purchaseForm = { channelId: '', remarks: '', itemList: [] };
            } else if (type === 'edit') {
                this.purchaseDialogTitle = '修改自采单';
                this.purchaseForm = {
                    channelId: row.channelId,
                    remarks: row.remarks,
                    itemList: (row.itemList || []).map(item => ({ ...item })),
                };
            }
            this.purchaseVisible = true;
        },
        closePurchaseDialog() {
            this.purchaseForm = { channelId: '', remarks: '', itemList: [] };
            this.$refs.purchaseForm && this.$refs.purchaseForm.resetFields();
            this.purchaseVisible = false;
        },
        onRowChange(row) {
            // 超量原因校验提示由提交时统一处理
            row.amount = ((row.goodsNum || 0) * (row.price || 0)).toFixed(2);
        },
        submitPurchase() {
            this.$refs.purchaseForm.validate((valid) => {
                if (!valid) return;
                const list = this.purchaseForm.itemList;
                if (list.length === 0) {
                    this.$message({ type: 'error', message: '请至少选择一件货物' });
                    return;
                }
                for (const item of list) {
                    if (!item.goodsNum || item.goodsNum <= 0) {
                        this.$message({ type: 'error', message: `货物「${item.goodsName}」自采数量必须大于0` });
                        return;
                    }
                    if (!item.price || item.price <= 0) {
                        this.$message({ type: 'error', message: `货物「${item.goodsName}」单价必须大于0` });
                        return;
                    }
                    // 库存量 > 自采量时必须填写原因（文档 8.3.1 / FR-ZC-02）
                    if (Number(item.whGoodsNum) > Number(item.goodsNum) && !item.overReason) {
                        this.$message({ type: 'error', message: `货物「${item.goodsName}」库存充足，请填写超量采购原因` });
                        return;
                    }
                }
                this.btnLoading = true;
                const send = {
                    ...this.purchaseForm,
                    totalAmount: this.totalAmount,
                    itemList: list.map((item, i) => ({
                        xh: i + 1,
                        goodsCode: item.goodsCode,
                        goodsName: item.goodsName,
                        goodsType: item.goodsType,
                        goodsNum: item.goodsNum,
                        price: item.price,
                        amount: ((item.goodsNum || 0) * (item.price || 0)).toFixed(2),
                        chanceId: item.chanceId,
                        overReason: item.overReason,
                    })),
                };
                addPersonalPurchase(send).then(res => {
                    this.btnLoading = false;
                    if (res && res.code === 200) {
                        this.$message({ type: 'success', message: '自采单提交成功' });
                        this.purchaseVisible = false;
                        this.getPurchaseList();
                    }
                }).catch(() => {
                    this.btnLoading = false;
                    this.$message({ type: 'warning', message: '提交失败（自采单接口待后端联调）' });
                });
            });
        },
        // 删除
        deletePurchase(row) {
            this.$confirm('确定删除该自采单吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                deletePersonalPurchase({ id: row.id }).then(res => {
                    if (res && res.code === 200) {
                        this.$message({ type: 'success', message: '删除成功' });
                        this.getPurchaseList();
                    }
                }).catch(() => {
                    this.$message({ type: 'warning', message: '删除失败（自采单接口待后端联调）' });
                });
            }).catch(() => { });
        },
        // 详情
        openDetail(row) {
            queryPersonalPurchase({ purchaseNo: row.purchaseNo }).then(res => {
                if (res && res.code === 200) {
                    this.detailForm = res.result || {};
                } else {
                    this.detailForm = { ...row };
                }
            }).catch(() => {
                this.detailForm = { ...row };
            });
            this.detailVisible = true;
        },
        // 审批记录
        openApprovalRecord(row) {
            approvalStageList({ applyCode: row.purchaseNo || row.id }).then(res => {
                if (res && res.code === 200) {
                    this.stageList = res.data;
                } else {
                    this.stageList = [];
                }
            }).catch(() => {
                this.stageList = [];
            });
            this.approvalRecordVisible = true;
        },
        // 选择货物
        getGoodsList() {
            this.goodsLoading = true;
            getGoodsByPage({
                goodsClassCode: this.goodsQueryForm.goodsClassCode,
                goodsName: this.goodsQueryForm.goodsName,
                category: this.goodsQueryForm.category,
                page: this.goodsPage,
                limit: this.goodsPageSize,
            }).then(res => {
                this.goodsLoading = false;
                if (res && res.code === 200) {
                    this.goodsTotal = res.total;
                    this.goodsList = (res.data || []).map(item => ({ ...item, checked: false }));
                } else {
                    this.goodsList = [];
                    this.goodsTotal = 0;
                }
            }).catch(() => {
                this.goodsLoading = false;
                this.goodsList = [];
                this.goodsTotal = 0;
            });
        },
        onGoodsSearch() {
            this.goodsPage = 1;
            this.getGoodsList();
        },
        onGoodsSizeChange(e) {
            this.goodsPage = 1;
            this.goodsPageSize = e;
            this.getGoodsList();
        },
        onGoodsCurrentChange(e) {
            this.goodsPage = e;
            this.getGoodsList();
        },
        confirmSelectGoods() {
            const selected = this.goodsList.filter(item => item.checked);
            if (selected.length === 0) {
                this.$message({ type: 'error', message: '未选择新的货物' });
                return;
            }
            selected.forEach(item => {
                const exist = this.purchaseForm.itemList.find(i => i.goodsCode === item.goodsCode);
                if (exist) {
                    this.$message({ type: 'warning', message: `货物「${item.goodsName}」已在明细中` });
                    return;
                }
                this.purchaseForm.itemList.push({
                    ...item,
                    goodsNum: 1,
                    price: '',
                    amount: 0,
                    chanceId: '',
                    overReason: '',
                });
            });
            this.selectVisible = false;
        },
        // 审批
        getApprList() {
            this.apprLoading = true;
            personalPurchaseApprovedList(this.apprQueryForm).then(res => {
                this.apprLoading = false;
                if (res && res.code === 200) {
                    this.apprTotal = res.count;
                    this.apprList = res.data;
                } else {
                    this.apprList = [];
                    this.apprTotal = 0;
                }
            }).catch(() => {
                this.apprLoading = false;
                this.apprList = [];
                this.apprTotal = 0;
            });
        },
        onApprSearch() {
            this.apprQueryForm.page = 1;
            this.getApprList();
        },
        onApprSizeChange(e) {
            this.apprQueryForm.page = 1;
            this.apprQueryForm.limit = e;
            this.getApprList();
        },
        onApprCurrentChange(e) {
            this.apprQueryForm.page = e;
            this.getApprList();
        },
        openApproveDialog(row) {
            this.approveForm = { ...row };
            this.approveVisible = true;
        },
        // 自采审批（approvalType 8 = 个人自采审批，待后端确认；超5万追加总经理为后端路由）
        approvalPurchase(approvalResult) {
            const title = approvalResult === 1 ? '审批通过' : '审批驳回';
            this.$prompt('请输入审批意见', title, {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                inputValue: approvalResult === 1 ? '同意' : '',
                inputPattern: /[^ \x20]+/,
                inputErrorMessage: '审批意见不能为空!'
            }).then(({ value }) => {
                applyApprovalReject({
                    approvalType: 8,
                    applyCode: this.approveForm.purchaseNo || this.approveForm.id,
                    approvalResult,
                    opinion: value
                }).then(res => {
                    if (res && res.code === 200) {
                        this.$message({ type: 'success', message: '操作成功' });
                        this.approveVisible = false;
                        this.apprQueryForm.func = 1;
                        this.getApprList();
                    }
                }).catch(() => {
                    this.$message({ type: 'warning', message: '审批失败（自采审批接口待后端联调）' });
                });
            }).catch(() => { });
        },
        // 下拉数据
        getChannelList() {
            getActiveFixedChannelList({ page: 1, limit: 9999 }).then(res => {
                if (res && res.code === 200) {
                    this.channelList = res.data;
                }
            }).catch(() => { });
        },
        loadProjectList() {
            if (isSales()) {
                getProjects().then(res => {
                    if (res && res.code === 200) {
                        this.projectList = res.data;
                    }
                });
            }
        },
        getGoodsClassList() {
            getGoodsClassList({ classFlag: "2" }).then(res => {
                if (res && res.code === 200) {
                    this.classOptions = res.data;
                }
            });
        },
    },
}
</script>
<style lang="scss" scoped>
.outer {
    height: 80vh;

    .el-form-item {
        margin-right: 20px;
    }

    .pageination {
        position: absolute;
        bottom: 10px;
        right: 10px;
        display: flex;
        justify-content: flex-end;
        margin-top: 5px;
    }

    .topSearch {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
    }

    .queryRow {
        overflow: hidden;
        display: flex;
    }

    .listTop {
        margin-bottom: 15px;
        font-size: 15px;
        font-weight: 450;
    }

    .totalPrice {
        display: flex;
        justify-content: flex-end;
        margin-top: 15px;
        font-size: 16px;

        .price {
            margin-right: 20px;
        }
    }

    .table {
        ::v-deep .el-table__cell {
            >:empty::before {
                content: '--';
                color: gray;
            }
        }
    }
}
</style>
